import React from 'react'
import { FormattedMessage } from 'react-intl'

const Results: React.FC = () => {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900">
        <FormattedMessage id="results.heading" defaultMessage="Results" />
      </h1>
      <p className="mt-2 text-sm text-gray-600">
        <FormattedMessage id="results.body" defaultMessage="Placeholder page for test results and reports." />
      </p>
    </div>
  )
}

export default Results
